import React from 'react';
import ChatHeader from './ChatHeader';
import ChatBody from './ChatBody';
import ChatFooter from './ChatFooter';

import '../css/Chat.css';  // Custom styles for the chat component

const ChatWindow = ({ showChat, messages, chatInput, chatBodyRef, handleInputChange, handleSendMessage, handleChatToggle, loading }) => {
  return (
    showChat && (
      <div className="chat-window">
        <ChatHeader onClose={handleChatToggle} />
        <ChatBody messages={messages} chatBodyRef={chatBodyRef} loading={loading} />
        <ChatFooter chatInput={chatInput} handleInputChange={handleInputChange} handleSendMessage={handleSendMessage} />
      </div>
    )
  );
};

export default ChatWindow;